import { MessagesTab } from '@/features/events/components/Detail/Tabs/MessagesTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/messages')({
  component: MessagesTab,
});
